import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

const LoginPage = () => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null); // 👈 for success/error message
  const navigate = useNavigate();

  const showMessage = (text, type = "success") => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 3000); // disappear after 3 sec
  };

  const handleLogin = async () => {
    try {
      const result = await api.checkLogin(userName, password);
      const table = result?.CheckLoginApi?.Table || [];
      const loginData = table[0];

      if (loginData?.Loginmsg === "Success") {
        showMessage("✅ Login Successful!", "success");

        sessionStorage.setItem("userName", loginData.UsrName);
        sessionStorage.setItem("userId", loginData.Usrid);

      navigate("/employee-data", { replace: true });// redirect slightly later
      } else {
        showMessage("❌ Username or Password incorrect", "error");
      }
    } catch (error) {
      console.error("Login failed:", error);
      showMessage("❌ Login Failed: " + error.message, "error");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/295/295128.png"
          alt="Login"
          style={styles.image}
        />

        <h2 style={styles.title}>Welcome Back 👋</h2>
        <p style={styles.subtitle}>Login to access attendance portal</p>

        <input
          type="text"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          placeholder="Enter Username"
          style={styles.input}
        />
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter Password"
          style={styles.input}
        />

        <button onClick={handleLogin} style={styles.button}>
          Login
        </button>
        {message && (
          <div
            style={{
              ...styles.toast,
              backgroundColor: message.type === "success" ? "#4caf50" : "#f44336",
            }}>
            {message.text}
          </div>
        )}
      </div>
    </div>
  );
};

// 🎨 Styles
const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    textAlign: "center",
    width: "400px",
    maxWidth: "90%",
    position: "relative",
  },
  image: {
    width: "100px",
    marginBottom: "20px",
  },
  title: {
    margin: "10px 0",
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
  },
  subtitle: {
    marginBottom: "20px",
    fontSize: "14px",
    color: "#666",
  },
  input: {
    padding: "12px",
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    marginBottom: "15px",
    outline: "none",
  },
  button: {
    backgroundColor: "#667eea",
    color: "#fff",
    padding: "12px 20px",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
    width: "100%",
  },
  toast: {
    marginTop: "20px",
    padding: "12px",
    borderRadius: "8px",
    color: "#fff",
    fontWeight: "bold",
    animation: "fadeInOut 3s ease",
  },
};

export default LoginPage;
